<template>
  <div>
    <portal to="modal-body">
      <div class="tw-p-5">
        <h2 class="tw-text-xl tw-font-medium tw-mb-2 font-title">Choose a badge for {{ mentee.name }} as a reward for completing the task</h2>
      </div>
      <div class="tw-p-5">
        <p class="tw-text-xs tw-uppercase tw-mb-2 tw-font-bold opacity-54">Badges</p>
        <div class="tw-flex tw-flex-wrap">
          <div
              v-for="badge in badges"
            :key="badge.id"
            :class="[
              'tw-w-1/2 md:tw-w-1/3 tw-border-2 tw-p-2 tw-rounded-10 tw-cursor-pointer tw-text-center tw-bg-gray-50',
              { 'tw-border-transparent hover:tw-bg-gray-100': selectedBadge?.id !== badge.id },
              { 'tw-bg-gray-100 tw-border-app-primary-orange': selectedBadge?.id === badge.id },
            ]"
            @click="selectBadge(badge)"
          >
            <UserPhoto :photo="badge.url" photo-size="tw-h-16 tw-w-16" />
            <p class="tw-text-sm tw-mb-2">{{ badge.name }}</p>
            <p class="tw-text-xs" v-html="badge.description"></p>
          </div>
        </div>
      </div>
    </portal>
    <portal to="modal-footer">
      <div class="tw-p-5">
        <BaseButton
          class="tw-w-full tw-bg-app-primary-orange tw-text-app-primary-orange-text tw-rounded-10 tw-py-3"
          :text="`Assign badge to ${mentee.name}`"
          :disabled="!selectedBadge || assigningBadge"
          @click="assignBadge()"
        />
      </div>
    </portal>
  </div>
</template>

<script>
import UserPhoto from '@/components/UserPhoto.vue';

export default {
  name: 'AssignTaskBadgeModal',
  components: {
    UserPhoto,
  },
  props: {
    mentee: {
      type: Object,
      required: true,
    },
    taskId: {
      type: [Number, String],
      required: true,
    },
  },
  data() {
    return {
      badges: [],
      selectedBadge: null,
      assigningBadge: false,
    };
  },
  methods: {
    async assignBadge() {
      if (!this.selectedBadge) return;

      this.assigningBadge = true;

      await this.$store.dispatch('assignBadgeToTask', {
        taskId: this.taskId,
        badgeId: this.selectedBadge.id,
        userId: this.mentee.id,
      });

      this.$emit('assigned');

      this.assigningBadge = false;
    },
    selectBadge(badge) {
      this.selectedBadge = badge;
    },
  },
  async mounted() {
    const result = await this.$store.dispatch('getProgramTaskBadges');

    if (Array.isArray(result)) {
      // Get random 6 badges from the result array
      this.badges = result.length > 6
        ? result.sort(() => 0.5 - Math.random()).slice(0, 6)
        : result;
    }
  },
};
</script>

<style>

</style>
